export default "__VITE_ASSET__6HjsR0nc__"